import { apiClient } from '../lib/apiClient';

/** Guided test session, "Say the value" (UC-15). */
export interface StreamUrl {
  url: string;
  expiresAt: string;
  sampleRate: number;
  /** Credits charged now (0 when the session was already charged). */
  chargedNow: number;
}

export interface SpokenValue {
  numbers: number[];
  command: 'next' | 'repeat' | 'skip' | null;
}

const base = (aquariumId: string): string => `/api/v1/aquariums/${encodeURIComponent(aquariumId)}/voice-stream`;

/** POST …/voice-stream/url — a short-lived Transcribe Streaming URL; the session is charged once. */
export async function getStreamUrl(aquariumId: string, sessionId: string, language: string): Promise<StreamUrl> {
  const response = await apiClient.post<{ data: StreamUrl }>(`${base(aquariumId)}/url`, { sessionId, language });
  return response.data;
}

/** POST …/voice-stream/parse — numbers and a command of one utterance (deterministic, no AI). */
export async function parseSpokenValue(aquariumId: string, text: string, language: string): Promise<SpokenValue> {
  const response = await apiClient.post<{ data: SpokenValue }>(`${base(aquariumId)}/parse`, { text, language });
  return response.data;
}
